module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppScaffold', {
    attrs: {
      "grid": ""
    }
  }, [(_vm.data && !_vm.loading) ? _c('Card', [_c('h1', [_vm._v(_vm._s(_vm.$tradFor(_vm.data.terms.name)))]), _vm._v(" "), _c('nav', [_c('RoundedButton', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.cancel))]), _vm._v(" "), _c('RoundedButton', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.save))])], 1), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('label', {
    attrs: {
      "for": "color"
    }
  }, [_vm._v(_vm._s(_vm.$trad.frameEditor.colorLabel))])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.frameConfig.color),
      expression: "frameConfig.color"
    }],
    attrs: {
      "id": "color",
      "type": "color"
    },
    domProps: {
      "value": (_vm.frameConfig.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.frameConfig.color = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.frameConfig.color),
      expression: "frameConfig.color"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.frameConfig.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.frameConfig.color = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$trad.frameEditor.width))]), _vm._v(" "), _c('td', [_c('NumericInput', {
    model: {
      value: (_vm.frameConfig.width),
      callback: function($$v) {
        _vm.frameConfig.width = $$v
      },
      expression: "frameConfig.width"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$trad.frameEditor.height))]), _vm._v(" "), _c('td', [_c('NumericInput', {
    model: {
      value: (_vm.frameConfig.height),
      callback: function($$v) {
        _vm.frameConfig.height = $$v
      },
      expression: "frameConfig.height"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$trad.frameEditor.thickness))]), _vm._v(" "), _c('td', [_c('NumericInput', {
    model: {
      value: (_vm.frameConfig.thickness),
      callback: function($$v) {
        _vm.frameConfig.thickness = $$v
      },
      expression: "frameConfig.thickness"
    }
  })], 1)])])])]) : _c('Card', [_c('Loader', {
    attrs: {
      "loading": true
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63c070fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/catalog/frame-editor.vue
// module id = 3230
// module chunks = 0